import React from 'react'
import PropTypes from 'prop-types'
import Barcode from 'react-barcode'
import './Barcode.scss'
import _ from 'lodash'

class BarcodeView extends React.Component {
  static defaultProps = {
    onFinish: _.noop,
    value: ''
  }

  static propTypes = {
    value: PropTypes.string
  }

  print = (e) => {
    e.preventDefault()
    var printSection = document.getElementById('printSection')
    if (!printSection) {
      printSection = document.createElement('div')
      printSection.id = 'printSection'
      document.body.appendChild(printSection)
    }
    const barcodeElem = $('.barcode-elem').first()
    printSection.innerHTML = barcodeElem.html()
    window.print()
    return false
  }

  render () {
    const { value } = this.props
    const barcodeElement = (
      <Barcode
        value={value}
        width={2.90}
        height={97}
        format={'code128'}
      />
    )
    return (
      <div>
        <div style={{ textAlign: 'right', marginTop: '20' }}>
          <div className='barcode-elem'>
            {barcodeElement}
          </div>
          <div style={{ marginBottom: '10' }}>
            <button className='btn btn-outline-primary' onClick={this.print}>
              Print Barcode
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default BarcodeView



// WEBPACK FOOTER //
// ./src/components/Barcode.js